// UI（器）の文言 — 英語。
//
// **ここに入れるのは器の文言だけ**（見出し・ラベル・ボタン・aria）。
// 作品の本文（シングル概要の紹介文・タイムラインの出来事）は album.site.ts が原本で、
// 歌詞・ライナーノーツ・名義・開示文は album.generated.ts（原本 md からの生成物）が持つ。
//
// キーはフラット。i18n/index.ts で keySeparator / nsSeparator を無効にしているので、
// ドットやコロンを含むキーもそのまま引ける（`nav.top` は入れ子ではなく1つのキー）。
// ja/common.ts と**キー集合を必ず揃える**こと（片方に無いキーはキー名がそのまま画面に出る）。

export default {
  'nav.top': 'TOP',
  'nav.lyrics': 'Lyrics',
  'nav.linerNotes': 'Liner Notes',
  'nav.menu': 'Menu',

  'lang.label': 'Language',
  'lang.en': 'EN',
  'lang.ja': '日本語',

  'hero.shareText': '“{{title}}” by {{artist}} — out now.',
  'hero.jacketAlt': '{{title}} - {{artist}} cover art',
  'hero.shareOnX': 'Share on X',
  'hero.shareOnFacebook': 'Share on Facebook',
  'hero.shareOnLine': 'Share on LINE',
  'hero.copyUrl': 'Copy URL',

  'overview.title': 'About the Single',
  'overview.artist': 'Artist',
  'overview.releaseDate': 'Release Date',
  'overview.label': 'Label',
  'overview.genre': 'Genre',
  'overview.credits': 'Credits',
  'overview.viewLyrics': 'Read the lyrics',
  'overview.readLinerNotes': 'Read the liner notes',

  'timeline.title': 'Release Info',

  'lyrics.note': 'Original lyrics by Gen.Y.Sakai',
  'linerNotes.note': 'Liner Notes by Gen.Y.Sakai',
};
